export default __webpack_public_path__ + "static/media/sapphire_sea.3ac20422.svg";